import { PassportUser, User } from '../../types';

export interface UserState {
  user: User | PassportUser;
  update: boolean;
}

export const UserInitialState: UserState = {
  user: null,
  update: false,
};
